// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._ZEzpy5FXLZ2vCXGACt1 {
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
}
.q9WL2jggYOmYIChAU9yu {
  border-bottom: 1px solid #ddd;
  display: flex;
  height: 100%;
}
.xzOSD1VP_zN4M6o3OtF8 {
  width: 240px;
  border-right: 1px solid #ddd;
}
.W8W3xR0Anyz4IUSTEdyU {
  flex: 1;
  padding: 10px;
}
.S50z3JeSOxSveq6acCLG {
  padding: 5px 10px;
  cursor: pointer;
}
.sJYGNxMYWzDbxWJKKiIu {
  border-top: 1px solid #ddd;
  padding: 10px 0;
}
.UxKXcHjLA6a4yyUbP5KE {
  color: #fff;
  background-color: #037C4B;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/Header/Simulation/Workbook/styles.module.less"],"names":[],"mappings":"AACA;EACE,6BAAA;EACA,mBAAA;AAAF;AAGA;EACE,6BAAA;EACA,aAAA;EACA,YAAA;AADF;AAIA;EACE,YAAA;EACA,4BAAA;AAFF;AAKA;EACE,OAAA;EACA,aAAA;AAHF;AAMA;EACE,iBAAA;EACA,eAAA;AAJF;AAOA;EACE,0BAAA;EACA,eAAA;AALF;AAQA;EACE,WAAA;EACA,yBAAA;AANF","sourcesContent":["\n.header {\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 5px;\n}\n\n.body {\n  border-bottom: 1px solid #ddd;\n  display: flex;\n  height: 100%;\n}\n\n.leftPanel {\n  width: 240px;\n  border-right: 1px solid #ddd;\n}\n\n.rightPanel {\n  flex: 1;\n  padding: 10px;\n}\n\n.actionItem {\n  padding: 5px 10px;\n  cursor: pointer;\n}\n\n.seqAdd {\n  border-top: 1px solid #ddd;\n  padding: 10px 0;\n}\n\n.active {\n  color: #fff;\n  background-color: #037C4B;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `_ZEzpy5FXLZ2vCXGACt1`,
	"body": `q9WL2jggYOmYIChAU9yu`,
	"leftPanel": `xzOSD1VP_zN4M6o3OtF8`,
	"rightPanel": `W8W3xR0Anyz4IUSTEdyU`,
	"actionItem": `S50z3JeSOxSveq6acCLG`,
	"seqAdd": `sJYGNxMYWzDbxWJKKiIu`,
	"active": `UxKXcHjLA6a4yyUbP5KE`
};
export default ___CSS_LOADER_EXPORT___;
